const initialState = {
  modalDetailPengajuanProduktif: true,
  listPengajuanProduktif: [],
  disetujuiProduktif: [],
  DiprosesProduktif: [],
  diajukanProduktif: [],
  ditolakProduktif: [],
  gagalTerkirimProduktif: [],
  listPengajuanByIdProduktif: [],
  detailPengajuanProduktif: [],
  valueColProduktif: "12",
  valueColPrevProduktif: "0",
  urlPreviewProduktif: "",
  titlePreviewProduktif: "",
  urlDokumenProduktif: "",
  getListKategoriJsonKoorProduktif: [],

  pengajuanLama: true,
  modalDetailInsentive: true,
  modalDetailInsentiveSpv: true,
  modalDetailInsentiveAM: true,
  listPengajuanBestada: [],
  listPencairan: [],
  listStatus: [],
  listTotalTargetUser: [],
  detailInsentive: [],
  totalPencairan: [],
  pencairanALLData: [],
  pencairanALLDataSpv: [],
  pencairanALLDataAM: [],
  limitPagePencairanAll: [],
  limitPagePencairanAllSpv: [],
  limitPagePencairanAllAM: [],
};

const pengajuanKoorProduktifReducer = (state = initialState, action) => {
  // console.log(initialState, "INITIAL STATE");
  let { type, data } = action;
  switch (type) {
    case "SET_STEP_PENGAJUAN_PRODUKTIF":
      return {
        ...state,
        modalDetailPengajuanProduktif: data,
      };
    case "SET_PENGAJUAN_LAMA":
      return {
        ...state,
        pengajuanLama: data,
      };
    case "SET_ALL_STATUS":
      return {
        ...state,
        listStatus: data,
      };
    case "SET_ALL_TOTAL_USER":
      return {
        ...state,
        listTotalTargetUser: data,
      };
    case "SET_ALL_PENGAJUAN_PRODUKTIF":
      return {
        ...state,
        listPengajuanProduktif: data,
      };
    case "SET_AMBIL_DITOLAK_PRODUKTIF":
      return {
        ...state,
        ditolakProduktif: data,
      };
    case "SET_AMBIL_DISETUJUI_PRODUKTIF":
      return {
        ...state,
        disetujuiProduktif: data,
      };
    case "SET_AMBIL_DIAJUKAN_PRODUKTIF":
      return {
        ...state,
        diajukanProduktif: data,
      };
    case "SET_AMBIL_DIPROSES_PRODUKTIF":
      return {
        ...state,
        DiprosesProduktif: data,
      };
    case "SET_AMBIL_GAGALTERKIRIM_PRODUKTIF":
      return {
        ...state,
        gagalTerkirimProduktif: data,
      };
    case "SET_ALL_PENGAJUAN_BESTADA":
      return {
        ...state,
        listPengajuanBestada: data,
      };
    case "SET_ALL_PENGAJUAN_BY_ID_PRODUKTIF":
      return {
        ...state,
        listPengajuanByIdProduktif: data,
      };
    case "SET_ALL_PENGAJUAN_BESTADA_BY_ID_PRODUKTIF":
      return {
        ...state,
        listPengajuanByIdProduktif: data,
      };
    case "SET_ALL_PENCAIRAN":
      return {
        ...state,
        listPencairan: data,
      };
    case "SET_ALL_TOTAL_PENCAIRAN":
      return {
        ...state,
        totalPencairan: data,
      };
    case "SET_DETAIL_PENGAJUAN_PRODUKTIF":
      return {
        ...state,
        detailPengajuanProduktif: data,
      };
    case "SET_PENCAIRAN_ALL":
      return {
        ...state,
        pencairanALLData: data,
      };
    case "SET_LIMIT_PAGE":
      return {
        ...state,
        limitPagePencairanAll: data,
      };
    case "SET_PENCAIRAN_ALL_SPV":
      return {
        ...state,
        pencairanALLDataSpv: data,
      };
    case "SET_LIMIT_PAGE_SPV":
      return {
        ...state,
        limitPagePencairanAllSpv: data,
      };
    case "SET_PENCAIRAN_ALL_AM":
      return {
        ...state,
        pencairanALLDataAM: data,
      };
    case "SET_LIMIT_PAGE_AM":
      return {
        ...state,
        limitPagePencairanAllAM: data,
      };
    case "SET_DETAIL_PENGAJUAN_BESTADA":
      return {
        ...state,
        detailPengajuanProduktif: data,
      };
    case "SET_DETAIL_INSENTIVE":
      return {
        ...state,
        modalDetailInsentive: data,
      };
    case "SET_DETAIL_INSENTIVE_SPV":
      return {
        ...state,
        modalDetailInsentiveSpv: data,
      };
    case "SET_DETAIL_INSENTIVE_AM":
      return {
        ...state,
        modalDetailInsentiveAM: data,
      };
    case "SET_DATA_DETAIL_INSENTIVE":
      return {
        ...state,
        detailInsentive: data,
      };
    case "PREVIEW_DOKUMEN_PRODUKTIF":
      return {
        ...state,
        valueColProduktif: "6",
        valueColPrevProduktif: "6",
        urlPreviewProduktif: data,
        titlePreviewProduktif: data,
      };
    case "HIDE_DOKUMEN_PRODUKTIF":
      return {
        ...state,
        valueColProduktif: "12",
        valueColPrevProduktif: "0",
        urlPreviewProduktif: "",
        titlePreviewProduktif: "",
      };
    case "SHOW_URL_DOKUMEN_PRODUKTIF":
      return {
        ...state,
        urlDokumenProduktif: data,
      };
    case "SET_GET_LIST_KATEGORI_KOOR_JSON":
      return {
        ...state,
        getListKategoriJsonKoorProduktif: data,
      };

    default:
      return state;
  }
};
export default pengajuanKoorProduktifReducer;
